import * as React from 'react';
import AdminUpgradeFeatures from 'admin/components/AdminUpgradeFeatures';
// @ts-ignore
import AdminUpgradeQuoteBox from 'admin/components/AdminUpgradeQuoteBox';
// @ts-ignore
import AdminUpgradeQuoteTotalBox from 'admin/components/AdminUpgradeQuoteTotalBox';
// @ts-ignore
import AdminUpgradeShareQuoteBanner from 'admin/components/AdminUpgradeShareQuoteBanner';
import Button from 'components/Button';
import Buttons from 'components/Buttons';
import EventTracking from 'lib/EventTracking';
import Row from 'components/Row';
import Text from 'components/Text';
import { UpgradePlanData, UpgradePlanQuote } from 'admin/components/AdminUpgradePlan/AdminUpgradePlanContainer';

import '../styles/AdminUpgradePlanQuoteForm.scss';

type Props = {
  orgName?: string;
  orgAddress?: string;
  orgType?: 'School' | 'District';
  startDate?: string;
  endDate?: string;
  price?: string;
  taxExempt?: boolean;
  tax?: string,
  quote?: UpgradePlanQuote,
  onAdvance: () => void;
  onContactSales: () => void;
  onTaxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onPersistState: (fields: UpgradePlanData, onSuccess: Function) => void;
};

class AdminUpgradePlanQuoteForm extends React.Component<Props> {
  trackingPrefix = 'admin_self_serve.v2.review_quote';

  componentDidMount() {
    this.track('view');
  }

  track = (key: string) => {
    EventTracking.trackKey(`${this.trackingPrefix}.${key}`);
  };

  handleTaxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.track('tax_exempt.click');
    this.props.onTaxChange(event);
  };

  render() {
    const {
      orgName,
      orgAddress,
      orgType,
      startDate,
      endDate,
      price,
      taxExempt,
      tax,
      onTaxChange,
      onPersistState,
      quote,
    } = this.props;

    return (
      <div className="AdminUpgradePlanQuoteForm">
        <div className="AdminUpgradePlanQuoteForm-content">
          <div className="AdminUpgradePlanQuoteForm-content-body">
            <div className="AdminUpgradePlanQuoteForm-content-body-forms">
              <Row>
                <Text weight="semibold" size="xlarge" element="div">
                  Your Remind plan quote
                </Text>
                <Text size="medium" element="div">
                  You’ll be able to review your order before completing your purchase.
                </Text>
              </Row>
              <Row size="medium">
                <AdminUpgradeQuoteBox
                  orgName={orgName}
                  orgAddress={orgAddress}
                  orgType={orgType ?? 'School'}
                  startDate={startDate}
                  endDate={endDate}
                  price={price}
                  taxExempt={taxExempt}
                  tax={tax}
                  handleTaxChange={this.handleTaxChange}
                  editable
                />
                <AdminUpgradeQuoteTotalBox quote={quote} />
                <div className="AdminUpgradePlanQuoteForm-content-body-forms-share">
                  <AdminUpgradeShareQuoteBanner
                    shareToken={quote?.shareToken}
                    showToast={false}
                    orgName={quote?.orgName}
                  />
                </div>
              </Row>
              <Buttons align="left">
                <Button onClick={() => onPersistState({}, this.props.onAdvance)}>
                  Upgrade now
                </Button>
                <Button level="secondary" onClick={() => onPersistState({}, this.props.onContactSales)}>
                  Contact sales
                </Button>
              </Buttons>
            </div>
            <div className="AdminUpgradePlanQuoteForm-content-body--desktop-side">
              <Row size="xxxlarge">
                <AdminUpgradeFeatures />
              </Row>
            </div>
          </div>
        </div>
        <div className="AdminUpgradePlanQuoteForm--mobile-bottom">
          <div className="AdminUpgradePlanQuoteForm-info-container">
            <AdminUpgradeFeatures />
          </div>
        </div>
      </div>
    );
  }
}

export { AdminUpgradePlanQuoteForm };
export default AdminUpgradePlanQuoteForm;
